
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator';
import { messages } from '@/@next/i18n';
import { TimelineContentData, TimelineContentEventData } from '@/@types/graphql';
import { CLoader } from '@/components/loader';
import { CImage } from '@/@next/components/image';
import { GameEvent } from './TimelineFullScreen.vue';

const config = {
  name: 'c-timeline-full-screen-game',
  i18n: { messages },
  components: {
    CLoader,
    CImage,
  }
};

@Component(config)
export default class CTimelineFullScreenGame extends Vue {
  @Prop({ type: Array, required: true }) gameEvents!: GameEvent[]
  @Prop({ type: Boolean, required: true }) started!: boolean
  @Prop({ type: String, required: true }) selectedEventId!: string

  startTime: any = 0;
  turns = 0;
  timer: any = null;
  time = 0;
  score = 0;
  showResult: boolean = false;

  @Watch('started')
  onStartedUpdate () {
    if (this.started && !this.timer) this.startGame()
  }

  @Watch('selectedEventId')
  onNewTurnUpdate () {
    if (this.selectedEventId) this.turns++
  }

  @Watch('gameCompleted')
  onGameCompletedUpdate () {
    if (!this.gameCompleted) return
    clearInterval(this.timer);
    this.showResult = true;
    setTimeout(() => {
      this.showResult = false
    }, 3000);
    setTimeout(() => {
      this.$emit('completed', this.time);
    }, 3500);
    // this.$emit('completed', this.time);

  }

  @Watch('gameFailed')
  onGameFailedUpdate () {
    if (!this.gameFailed) return
    this.showResult = true;
    setTimeout(() => {
      this.showResult = false
    }, 3000);
  }

  startGame () {
    this.started = true;
    this.time = 0;
    this.startTimer();
  }

  startTimer () {
    if (!this.timer)
      this.timer = setInterval(() => {
        this.time++;
      }, 1000);
  }

  getFormattedTime () {
    const mm = Math.floor(this.time / 60)
    const ss = this.time % 60
    return `${mm}:${ss}`
  }

  get eventFound () {
    return this.gameEvents.filter((e: GameEvent) => e.goodImageId === e.image?.id).length
  }

  get eventWithImage () {
    return this.gameEvents.filter((e: GameEvent) => e.image)
  }

  get gameCompleted () {
    return this.eventFound === this.gameEvents.length;
  }

  get gameFailed () {
    return this.eventWithImage.length === this.gameEvents.length && !this.gameCompleted
  }
}
